export const handleFilterParams = <T>(filter: T) =>
	Object.fromEntries(Object.entries(filter as any).filter(([, value]) => !!value))
